export default __webpack_public_path__ + "static/media/sr.9a7e8bfd.svg";